const metadata = {
  fields: [
    'id',
    'name',
    'description',
    'location',
    'mode_of_exam',
    'product_id',
    'slots',
    'restrictions',
    'created_at',
    'updated_at',
    'created_by',
    'updated_by',
    'test_event_id',
    'status',
    { paper_requests: ['id', 'name'] },
    { papers: ['id', 'paper_id', 'paper_smart_id', 'test_track_id', 'slot_data', 'status'] },
    { product: ['name', 'test_track_ids', 'sections', 'section_ids'] },
    { assigned_papers: ['id', 'active', 'test_track_id', 'slot_assigned'] },
  ],
}

export default metadata
